import * as React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../../components/Header/Header';
import { GetString } from '../../../components/StringResourceManager';
// Constants
import { APP_TITLE } from '../../../utils/constants';
import { makeStyles, Paper, Theme, createStyles } from '@material-ui/core';
import AccessControlHistoryContainer from '../../../components/AccessControl/History/AccessControlHistory';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paperGrid: {
      marginTop: theme.spacing(7),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
  })
);

export default function AccessControlHistorySubMenu() {
  const classes = useStyles();

  return (
    <>
      <Helmet>
        <title>
          {GetString('ACCESS_CONTROL')} | {APP_TITLE}
        </title>
      </Helmet>
      <Header open={true} pageDisplayed={GetString('ACCESS_CONTROL')} />
      <Paper className={classes.paperGrid}>
        <AccessControlHistoryContainer />
      </Paper>
    </>
  );
}
